module.exports = __webpack_public_path__ + "static/media/a.427a7630.svg";